/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.TagManager.Host.Api
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type MapCreditsOptionsMapDestination = typeof MapCreditsOptionsMapDestination[keyof typeof MapCreditsOptionsMapDestination] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MapCreditsOptionsMapDestination = {
  AWS: 'AWS',
  AnyAWSDBAService: 'AnyAWSDBAService',
  EC2: 'EC2',
} as const;
